import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend, { type HttpBackendOptions } from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { I18nNamespace } from './i18n-namespaces';

i18n.use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init<HttpBackendOptions>({
        fallbackLng: 'en',
        supportedLngs: ['en'],
        load: 'languageOnly',
        debug: false,
        defaultNS: I18nNamespace.COMMON,
        ns: Object.values(I18nNamespace),
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
            queryStringParams: {
                v: __LOCALE_CACHE_VERSION__,
            },
        },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
        },
        react: {
            useSuspense: true,
        },
    });

export default i18n;
